import { createContext, useContext, useEffect, useState } from 'react';
import useFeatureActions from '../hooks/APIHooks/users/useFeatureActions';
import useRolePermissionsActions from '../hooks/APIHooks/users/useRolePermissionsActions';
import { Feature } from '../types/features';
import {
  RolePermission,
  RolePermissionTableData,
} from '../types/rolePermissions';

// datatype of the context declared here
interface IRolePermission {
  featureList: Array<Feature>;
  rolePermissionList: Array<RolePermission>;
  rolePermissionTableList: Array<RolePermissionTableData>;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

// creating the context here
const RolePermissionContext = createContext<IRolePermission | null>(null);

const RolePermissionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // integration of react hooks here
  const [rolePermissionTableList, setRolePermissionTableList] = useState<
    Array<RolePermissionTableData>
  >([]);

  // integration of custom API hooks here
  const { getRolePermissionListHandler } =
    useRolePermissionsActions('rolePermissionList');
  const { getFeatureListHandler } = useFeatureActions('getFeatureList');

  console.log(
    'ROLE PERMISSION LIST: ',
    getRolePermissionListHandler.data?.data
  );

  console.log('PERMISSION FEATURE LIST: ', getFeatureListHandler.data?.data);

  // formatting role permissions for table data here
  useEffect(() => {
    if (
      getRolePermissionListHandler.data?.is_success &&
      getFeatureListHandler.data?.is_success
    ) {
      let permissions = {};
      let permissionTableList: Array<RolePermissionTableData> = [];

      const totalRoleCount = getRolePermissionListHandler.data.data.map(
        (permission) => permission.role_name
      ).length;

      getFeatureListHandler.data.data.map((feature) =>
        getRolePermissionListHandler.data.data.forEach((permission) => {
          const permissionObj = {
            role: permission.role,
            role_name: permission.role_name,
            permission_names:
              permission.role_permissions.find(
                (rolePermission) => rolePermission.feature === feature.name
              )?.permission_names || [],
          };

          permissions = {
            ...permissions,
            [permissionObj['role_name']]: {
              role: permissionObj.role,
              permission_names: permissionObj.permission_names,
            },
          };

          if (Object.keys(permissions).length === totalRoleCount) {
            permissionTableList = [
              ...permissionTableList,
              {
                id: feature.id,
                feature_name: feature.name,
                permissions,
              },
            ];

            permissions = {};
          }
        })
      );

      setRolePermissionTableList(permissionTableList);
    }
  }, [getRolePermissionListHandler.data, getFeatureListHandler.data]);

  console.log('PERMISSIONS TABLE: ', rolePermissionTableList);

  // creating the context provider here
  return (
    <RolePermissionContext.Provider
      value={{
        featureList: getFeatureListHandler.data?.data || [],
        rolePermissionList: getRolePermissionListHandler.data?.data || [],
        rolePermissionTableList,
        isError: getRolePermissionListHandler.isError,
        isLoading: getRolePermissionListHandler.isLoading,
        isSuccess: getRolePermissionListHandler.isSuccess,
      }}
    >
      {children}
    </RolePermissionContext.Provider>
  );
};

export default RolePermissionProvider;

// custom hook to access role permission context declared here
export const useRolePermissionContext = () => {
  const context = useContext(RolePermissionContext);

  if (!context) {
    throw new Error(
      'useRolePermissionContext must be within RolePermissionProvider!'
    );
  }

  return context;
};
